import React from 'react';

import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';

const Reviews = () => {
  const { l3Options: tabs } = useRouteToNavLevels();

  const Component = tabs[0]?.content;

  return (
    Component && (
      <Component
        cohort={{
          id: tabs[0].cohortId,
          name: tabs[0].label,
        }}
      />
    )
  );
};

export default Reviews;
